module.exports = __webpack_public_path__ + "media/assets/icons/triangle-down-rounded-ef4fefee96aa837e89a04176cf216927.svg";